export const newsList = [
  {
    id: "n1",
    title: "《长夜将明》正式收官，全员演技获赞登顶热搜",
    date: "2024-09-28",
    summary:
      "悬疑剧《长夜将明》迎来大结局，凭借扎实的剧本与演员群的出色表演，成为今年口碑最高的国产剧集之一。",
    movieId: "m1",
  },
  {
    id: "n2",
    title: "《山海秘境》发布终极预告，东方奇幻视觉震撼",
    date: "2024-09-25",
    summary:
      "电影《山海秘境》曝光终极预告，九重幻境的瑰丽场景首次完整呈现，被网友称为「国产奇幻新的天花板」。",
    movieId: "m3",
  },
  {
    id: "n3",
    title: "陆时衍谈《暗涌》拍摄幕后：三个月减重十五斤",
    date: "2024-09-22",
    summary:
      "演员陆时衍在采访中首次分享谍战剧《暗涌》的拍摄经历，为贴近角色他进行了为期三个月的形体训练。",
    movieId: "m5",
  },
  {
    id: "n4",
    title: "《追光者》口碑发酵，励志题材再受关注",
    date: "2024-09-18",
    summary:
      "电影《追光者》上映两周，凭借真实的改编故事与克制的叙事风格，引发了关于「重新出发」的广泛讨论。",
    movieId: "m9",
  },
  {
    id: "n5",
    title: "《老巷人家》高分完结，烟火气治愈无数观众",
    date: "2024-09-12",
    summary:
      "家庭剧《老巷人家》以生活流叙事收获高口碑，拆迁背景下的三户人家让观众找回了久违的邻里温情。",
    movieId: "m8",
  },
  {
    id: "n6",
    title: "《星际迷途》重映引热议，硬科幻仍是稀缺品",
    date: "2024-09-06",
    summary:
      "被誉为「近年来最克制的太空电影」的《星际迷途》宣布重映，关于孤独与人性的表达再度引发讨论。",
    movieId: "m7",
  },
  {
    id: "n7",
    title: "林晚舟新作官宣，再度挑战悬疑题材",
    date: "2024-08-30",
    summary:
      "演员林晚舟官宣加盟全新悬疑剧项目，这也是她继《长夜将明》之后再次出演高智商女性角色。",
    movieId: "m1",
  },
  {
    id: "n8",
    title: "春日治愈剧《春日暖阳》长尾效应显著",
    date: "2024-08-24",
    summary:
      "播出一年后，《春日暖阳》依旧是众多观众心中的「电子榨菜」，慢节奏的治愈叙事被反复安利。",
    movieId: "m2",
  },
];

export const topics = [
  {
    id: "t1",
    title: "2024 热播剧盘点",
    desc: "从悬疑到治愈，一份帮你快速跟上今年的追剧清单。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20collage%20banner%20of%20several%20glowing%20tv%20screens%20stacked%20in%20a%20dark%20room%20with%20warm%20orange%20light%20and%20deep%20blue%20shadows%2C%20modern%20entertainment%20magazine%20atmosphere%2C%20cinematic%20high%20detail%20composition&width=800&height=500&seq=topic-01&orientation=landscape",
    link: "/category/tv",
  },
  {
    id: "t2",
    title: "国产奇幻的进阶之路",
    desc: "从特效到世界观，看看东方奇幻这些年的成长。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20banner%20of%20a%20mystical%20eastern%20fantasy%20mountain%20landscape%20in%20deep%20blue%20mist%20with%20glowing%20orange%20sunrise%2C%20artistic%20magazine%20illustration%20style%2C%20cinematic%20high%20detail%20composition&width=800&height=500&seq=topic-02&orientation=landscape",
    link: "/category/movie",
  },
  {
    id: "t3",
    title: "演技派演员图鉴",
    desc: "不靠流量靠作品，认识这几位稳扎稳打的演员。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20banner%20of%20a%20backstage%20theater%20scene%20with%20warm%20orange%20spotlight%20and%20deep%20blue%20shadows%2C%20dramatic%20artistic%20magazine%20atmosphere%2C%20cinematic%20high%20detail%20composition&width=800&height=500&seq=topic-03&orientation=landscape",
    link: "/actors",
  },
];